<template>
  <div class="main-layout">
    <LoginForm />
  </div>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue'

export default {

  name: 'Login',

  components: {
    LoginForm,
  },

}
</script>

<style scoped>
.main-layout {
  height: 100vh;
  overflow: hidden;
  display: grid;
  grid-template-columns: auto 1fr;
  padding: 1rem;
  overflow-y: auto;
}
</style>
